// extracted by mini-css-extract-plugin
export default {"reservations":"ConfirmedReservations_reservations__tYutf"};